import { render, staticRenderFns } from "./onVtwd.vue?vue&type=template&id=0ece0760"
import script from "./onVtwd.vue?vue&type=script&lang=js"
export * from "./onVtwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports